import { createAction, createSlice } from "@reduxjs/toolkit";
import {
	AffiliatePayment,
	AffiliatePaymentQueryParams,
	DataUpdatePayment,
} from "../type";
import { RootState } from "store/store";

export interface AffiliatePaymentState {
	affiliatePaymentList: AffiliatePayment[];
	affiliatePaymentDetail: AffiliatePayment | null;
	affiliatePaymentTotal: number;
}

const initialState: AffiliatePaymentState = {
	affiliatePaymentList: [],
	affiliatePaymentDetail: null,
	affiliatePaymentTotal: 0,
};

export const affiliatePaymentSlice = createSlice({
	name: "affiliatePayment",
	initialState,
	reducers: {
		setListAffiliatePayment: (state, action) => {
			state.affiliatePaymentList = action.payload.data;
			state.affiliatePaymentTotal = action.payload.total;
		},
		setDetailAffiliatePayment: (state, action) => {
			state.affiliatePaymentDetail = action.payload.data;
		},
	},
});

export const { setListAffiliatePayment, setDetailAffiliatePayment } =
	affiliatePaymentSlice.actions;

export const selectAffiliatePaymentList = (state: RootState) =>
	state.affiliatePayment.affiliatePaymentList;
export const selectAffiliatePaymentDetail = (state: RootState) =>
	state.affiliatePayment.affiliatePaymentDetail;
export const selectAffiliatePaymentTotal = (state: RootState) =>
	state.affiliatePayment.affiliatePaymentTotal;

export interface GetListAffiliatePaymentPayload {
	query: AffiliatePaymentQueryParams;
	callback: () => void;
}

export const getListAffiliatePaymentAsync = createAction(
	"affiliatePayment/getListAffiliatePaymentAsync",
	payload => ({
		payload,
	}),
);

export interface GetDetailAffiliatePaymentPayload {
	id: string;
	callback: () => void;
}

export const getDetailAffiliatePaymentAsync = createAction(
	"affiliatePayment/getDetailAffiliatePaymentAsync",
	payload => ({
		payload,
	}),
);

export interface UpdateAffiliatePaymentPayload {
	id: string;
	callback: () => void;
	data: DataUpdatePayment;
}

export const updateAffiliatePaymentAsync = createAction(
	"affiliatePayment/updateAffiliatePaymentAsync",
	payload => ({
		payload,
	}),
);

export interface UpdateStatusAffiliatePaymentPayload {
	id: string;
	callback: () => void;
	data: {
		status: string;
	};
}

export const updateStatusAffiliatePaymentAsync = createAction(
	"affiliatePayment/updateStatusAffiliatePaymentAsync",
	payload => ({
		payload,
	}),
);

export default affiliatePaymentSlice.reducer;
